import mixins from 'vue-typed-mixins';

import { 取込Api } from '@/openapi/user';
import { E取込データ種別, E取込分類, E製造原価科目未使用フラグ } from '@/openapi/enum';

import 計画書Mixin from '@/entries/user/mixins/計画書Mixin';
import 取込Mixin from '@/entries/user/mixins/取込Mixin';
import UserApiUtility from '@/classes/common/UserApiUtility';

// 取込分類に応じた選択肢を定義
const SELECTIONS = [
  {
    e取込分類: [E取込分類.決算書],
    options: [
      E取込データ種別.取込なし,
      E取込データ種別.貸借対照表勘定式,
      E取込データ種別.貸借対照表報告式,
      E取込データ種別.損益計算書,
      E取込データ種別.販売費および一般管理費内訳書,
      E取込データ種別.製造原価報告書,
    ],
  },
  {
    e取込分類: [E取込分類.固定資産台帳],
    options: [E取込データ種別.取込なし, E取込データ種別.固定資産台帳],
  },
  {
    e取込分類: [E取込分類.月次貸借対照表, E取込分類.実績月次貸借対照表],
    options: [E取込データ種別.取込なし, E取込データ種別.月次貸借対照表],
  },
  {
    e取込分類: [E取込分類.月次損益計算書_月次製造原価報告書, E取込分類.実績月次損益計算書_実績月次製造原価報告書],
    options: [E取込データ種別.取込なし, E取込データ種別.月次損益計算書, E取込データ種別.月次製造原価報告書],
  },
];

export default mixins(計画書Mixin, 取込Mixin).extend({
  name: 'C取込データ選択Dialog',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    max取込枚数: {
      type: Number,
      required: true,
    },
    変換枚数: {
      type: Number,
      required: true,
    },
  },

  data(): {
    e取込データ種別s: E取込データ種別[];
    totalPage: number;
  } {
    return {
      e取込データ種別s: [],
      totalPage: 0,
    };
  },

  computed: {
    options(): E取込データ種別[] {
      if (this.importInfo === null) return [];
      const selection = SELECTIONS.find((s) => s.e取込分類.includes(this.importInfo.取込分類));
      if (selection === undefined) return [];

      const options = selection.options;
      if (
        [E取込分類.月次損益計算書_月次製造原価報告書, E取込分類.実績月次損益計算書_実績月次製造原価報告書].includes(
          this.importInfo.取込分類
        ) &&
        this.事業所.c製造原価科目未使用フラグ === E製造原価科目未使用フラグ.使用しない
      ) {
        return options.filter((o) => o !== E取込データ種別.月次製造原価報告書);
      }

      return options;
    },
  },

  filters: {
    optionLabel(selection: E取込データ種別): string {
      return E取込データ種別[selection];
    },
  },

  watch: {
    async visible(): Promise<void> {
      if (!this.visible || !this.importInfo.file) return;
      const response = await UserApiUtility.ogApi(取込Api).import取込Pdf(
        this.計画書.pk,
        this.importInfo.取込分類,
        this.importInfo.年,
        this.importInfo.file,
        this.importInfo.部門pk
      );
      this.totalPage = response.data.totalPage;
      this.e取込データ種別s = new Array(this.totalPage).fill(
        this.importInfo.取込分類 === E取込分類.固定資産台帳 ? E取込データ種別.固定資産台帳 : E取込データ種別.取込なし
      );
    },
  },

  methods: {
    selectPage(): void {
      const selectPageCount = this.e取込データ種別s.filter((s) => s !== E取込データ種別.取込なし).length;
      // 一つも選択されていない場合はエラー
      if (selectPageCount === 0) {
        window.alert('選択されていません');
        return;
      }
      // 取込上限を超える場合はエラー
      if (this.max取込枚数 < this.変換枚数 + selectPageCount) {
        window.alert('取込枚数を超えています');
        return;
      }
      // 貸借対照表勘定式と貸借対照表報告式を両方設定している場合はエラー
      if (
        this.e取込データ種別s.includes(E取込データ種別.貸借対照表勘定式) &&
        this.e取込データ種別s.includes(E取込データ種別.貸借対照表報告式)
      ) {
        window.alert('貸借対照表勘定式と貸借対照表報告式は同時に選択できません');
        return;
      }

      this.set取込データ種別s(this.e取込データ種別s);
      this.$emit('selectPage');
    },
  },
});
